<button
  aria-label="Copy link"
  type="button"
  [ngClass]="{ border: hasBorder }"
  [disabled]="!returnLink"
  class="copy"
  mat-icon-button
  (click)="copy(tooltip)"
>
  <span
    #tooltip="matTooltip"
    class="tooltip-point"
    matTooltip="Link Copied!"
    matTooltipShowDelay="500"
    matTooltipClass="green"
    matTooltipPosition="above"
  ></span>
  <fa-icon matPrefix [icon]="['far', 'copy']" class="text-blue mr-1 ml-3 icon">
  </fa-icon>
</button>
